module.exports = __webpack_public_path__ + "media/images/emblems/Gingins-coat_of_arms-fc14595dd4a1f520ef8c6485db1dd256.svg";